import React from 'react';
import NavBar from 'js/components/NavBar';

export default () => {
    return <NavBar allowSwitchRoles={false} noLogoLink />;
};
